<template>
  <section class="appointDetailDiv">
    <h1 class="header">查看预约详情</h1>
    <!-- 模块一 -->
    <section>
      <div class="title">
        <div class="tag"></div>
        <span class="text">预约信息</span>
      </div>
      <div class="content">
        <el-row>
          <el-col :span="9">运输单位：{{ params.name }}</el-col>
          <el-col :span="8">办理业务：{{ params.remark }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="9">产品线：{{ params.name }}</el-col>
          <el-col :span="8">车牌号：{{ params.remark }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="9">车辆类型：{{ params.name }}</el-col>
          <el-col :span="8">司机姓名：{{ params.remark }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="9">手机号码：{{ params.name }}</el-col>
          <el-col :span="8">身份证号：{{ params.remark }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="9"
            >预约类型：<span style="color: #008b5e;">{{
              params.name
            }}</span></el-col
          >
          <el-col :span="8">预约到厂时间：{{ params.remark }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6"
            >身份证正反面：
            <div>
              <el-image class="cardimg" :src="src" :preview-src-list="srcList">
              </el-image>
              <el-image class="cardimg" :src="src" :preview-src-list="srcList">
              </el-image>
            </div>
          </el-col>
          <el-col :span="6"
            >驾驶证主副页：
            <div>
              <el-image class="cardimg" :src="src" :preview-src-list="srcList">
              </el-image>
              <el-image class="cardimg" :src="src" :preview-src-list="srcList">
              </el-image>
            </div>
          </el-col>
          <el-col :span="6"
            >行驶证主副页：
            <div>
              <el-image class="cardimg" :src="src" :preview-src-list="srcList">
              </el-image>
              <el-image class="cardimg" :src="src" :preview-src-list="srcList">
              </el-image>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 模块二 -->
    <section style="padding-top: 10px;">
      <div class="title">
        <div class="tag"></div>
        <span class="text">过磅信息</span>
      </div>
      <div class="content">
        <el-row>
          <el-col>
            过磅状态：<span style="color: #008B5E;">{{ params.name }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            >过磅数据：{{ params.name
            }}<span style="margin-left: 25px;"
              >过磅时间：9月20日 12：15</span
            ></el-col
          >
        </el-row>
        <el-row>
          <el-col
            >回磅数据：{{ params.name
            }}<span style="margin-left: 25px;"
              >回磅时间：9月20日 12：30</span
            ></el-col
          >
        </el-row>
      </div>
    </section>

    <!-- 模块三 -->
    <section>
      <div class="timeLine">
        <div class="timeBlock">
          <div class="title">进厂前</div>
          <el-timeline id="firstTimeline">
            <el-timeline-item
              v-for="(activity, index) in activities1"
              :key="index"
              :icon="activity.icon"
              :type="activity.type"
              :color="activity.color"
              :size="activity.size"
              :timestamp="activity.timestamp"
            >
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="timeBlock">
          <div class="title">进厂后</div>
          <el-timeline id="secondTimeline">
            <el-timeline-item
              v-for="(activity, index) in activities2"
              :key="index"
              :icon="activity.icon"
              :type="activity.type"
              :color="activity.color"
              :size="activity.size"
              :timestamp="activity.timestamp"
            >
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </section>

    <!-- 模块四 -->
    <section>
      <div style="margin-top: 30px;">
        <el-button
          size="small"
          @click="
            $router.push({
              path: '/'
            })
          "
          >返回</el-button
        >
      </div>
    </section>
  </section>
</template>

<script>
export default {
  data() {
    return {
      params: {
        keyword: "", // 关键字搜索
        name: "珠海坚力运输有限公司",
        remark: "成品提货"
      },
      src:
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg"
      ],
      activities1: [
        {
          content: "预约成功，操作人：赵仁",
          timestamp: "2018-04-03 20:46",
          color: "#229A73"
        },
        {
          content: "修改预约信息，操作人：赵仁",
          timestamp: "2018-04-03 20:46",
          color: "#229A73"
        },
        {
          content: "司机报到成功",
          timestamp: "2018-04-03 20:46",
          color: "#229A73"
        },
        {
          content: "确认放行进厂，操作人：王建国（2号门）",
          timestamp: "2018-04-03 20:46",
          color: "#229A73"
        }
      ],
      activities2: [
        {
          content: "预约成功，操作人：赵仁",
          timestamp: "2018-04-03 20:46",
          color: "#00C8D2"
        },
        {
          content: "修改预约信息，操作人：赵仁",
          timestamp: "2018-04-03 20:46",
          color: "#00C8D2"
        },
        {
          content: "司机报到成功",
          timestamp: "2018-04-03 20:46",
          color: "#00C8D2"
        }
      ]
    };
  },

  async activated() {},

  created() {},

  methods: {},

  mounted() {}
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.appointDetailDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }

  .title {
    & > .tag {
      display: inline-block;
      height: 21px;
      background: #00a0fa;
      width: 5px;
      margin-right: 7px;
      vertical-align: bottom;
    }
    & > .text {
      font-size: 18px;
      color: #333333;
    }
  }

  .content {
    margin: 16px 11px;
    font-size: 14px;
    color: #333;
    line-height: 30px;
    .cardimg {
      width: 90px;
      height: 56px;
      margin-top: 7px;
      margin-right: 17px;
    }
    .tips {
      display: inline-block;
      margin-left: 10px;
      font-size: 11px;
      color: #ec3f67;
    }
    // 随行人员
    .tbTitle {
      display: inline-block;
      vertical-align: top;
    }
    .tbCell {
      display: inline-block;
      text-align: center;
      margin: 8px 20px 10px 0px;
      & > .cellLeft {
        width: 280px;
        line-height: 35px;
        font-size: 16px;
        background: rgb(247, 247, 247);
        border-radius: 4px 4px 0px 0px;
      }
      & > .cellRight {
        display: flex;
        font-size: 12px;
        & > .left {
          flex: 1.2;
          border: 1px solid #f7f7f7;
          text-align: right;
          padding: 0px 8px 0px 0px;
        }
        & > .right {
          flex: 2;
          border: 1px solid #f7f7f7;
          border-left: 0px;
          text-align: left;
          padding: 0px 0px 0px 15px;
        }
      }
    }
  }
  // 时间线
  .timeLine {
    display: flex;
    margin-top: 30px;
    & > .timeBlock {
      padding: 0px 35px;
      background: #f2f9f7;
      margin-right: 20px;
      & > .title {
        text-align: center;
        line-height: 56px;
        font-feature-settings: 18px;
      }
    }
  }

  .el-image__inner {
    object-fit: cover;
  }
}
</style>
